import { reportError } from '@pypestream/utils';

/**
 * Reports a failure this machine shows the user but does not throw.
 *
 * Manager's invoke-level reporter (`xstate.utils.ts`) fires on `onError`, so it
 * covers every failure that reaches `onErrorActions` — which is all but two of
 * this file's error toasts. The exceptions are the user-delete paths, which
 * `sendUserMessage` and then `return`: the invoke resolves, `onError` never
 * runs, and nothing records that removing a user failed.
 *
 * One of the two is a failure the transport calls a success — a 200 carrying
 * `errorDetails` — which no amount of rejection handling would have caught.
 *
 * Guarded, for the reason every reporter in these apps is: the toast beside it
 * is the user's only signal, and telemetry must not be able to remove it.
 */
export const reportManagerFailure = (
  error: unknown,
  source: string,
  extra: Record<string, unknown> = {}
): void => {
  try {
    reportError(error, {
      source,
      tags: { app: 'manager' },
      extra,
    });
  } catch {
    // Deliberately empty — see above.
  }
};
